<template>
  <div style="position: relative">
    <iframe
      v-if="this.version!=''"
      id="baidutongji"
      name="baidutongji"
      :src="`https://aiplugin.5118.com/Pluginstat/?p=checkMainICP&v=${version}`"
      style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"
    ></iframe>
    <div dir="rtl" class="page" style="height: 100%;">
      <div dir="ltr">
        <div class="col-15 right" style="margin-top: 10px">
          <button @click="jump_domain_url(getdomain)" class="btn">备案快速查询></button>
        </div>
        <p class="checkdomainname" :title="getdomain">当前域名【{{getdomain}}】</p>
        <div class="dotted-line"></div>
        <div v-if="isdata">
          <div class="icpinfo">
            <span>ICP备案主体信息</span>
            <p class="line"></p>
            <p>主办单位名称：</p>
            <p class="spancolor companyLength" :title="datalist.company_name"
            @click="jump_company_url(datalist.company_name)" style="max-width: 220px;">{{datalist.company_name}}</p>
            <p class="dotted-line"></p>
            <p class="pleft">备案/许可证号：</p>
            <p class="spancolor pright" @click="jump_icp_url(datalist.icp_license)">{{datalist.icp_license}}</p>
            <p class="dotted-line lineheight"></p>
            <p class="pleft">审核时间：</p>
            <p class="pright">{{reptime(datalist.confirm_time)}}</p>
            <p class="dotted-line lineheight"></p>
            <p class="pleft">主办单位性质：</p>
            <p class="pright">{{datalist.company_type}}</p>
            <p class="dotted-line lineheight"></p>
            <p class="pleft">旗下备案网站数：</p>
            <p class="spancolor pright" @click="jump_company_url(datalist.company_name)">{{datalist.domain_count}}</p>
            <p class="dotted-line lineheight"></p>
          </div>
          <div class="icpinfo">
            <span>ICP备案网站信息</span>
            <p class="line"></p>
            <p class="pleft">网站名称：</p>
            <p class="spancolor pright companyLength" :title="datalist.site_name"
              @click="jump_name_url(datalist.site_name)" style="max-width: 170px;">{{datalist.site_name}}</p>
            <p class="dotted-line lineheight"></p>
            <p class="pleft">网站首页地址：</p>
            <p class="spancolor pright companyLength" @click="jump_domain_url(get_index_url(datalist.main_gage))"
             style="max-width: 140px;">{{datalist.main_gage}}</p>
            <p class="dotted-line lineheight"></p>
            <p class="pleft">网站负责人：</p>
            <p class="pright">{{datalist.owner}}</p>
            <p class="dotted-line lineheight"></p>
            <p class="pleft">备案/许可证号：</p>
            <p class="spancolor pright" @click="jump_icp_url(datalist.site_license)">{{datalist.site_license}}</p>
            <p class="dotted-line lineheight"></p>
            <p class="pleft">网站前置审批项：</p>
            <p class="pright companyLength" :title="datalist.site_preconfirm"
              style="max-width: 120px;">{{datalist.site_preconfirm}}</p>
            <p class="dotted-line lineheight"></p>
            <p class="pleft">网站域名：</p>
            <p class="spancolor pright" @click="jump_domain_url(datalist.domain_name)">{{datalist.domain_name}}</p>
            <p class="dotted-line lineheight"></p>
            <!-- <p class="pleft">首页是否悬挂备案号：</p>
            <p class="pright">{{datalist.icp_status}}</p>
            <p class="dotted-line lineheight"></p> -->
          </div>
        </div>
        <div v-else style="margin: 250px 80px;font-size: 14px;">暂无数据</div>

        <div class="center">
          <button @click="jump_domain_url(getdomain)" class="btn btnbox">查看更多备案详情</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  componentName: "CheckICP",
  data() {
    return { };
  },
  computed: {
    version: {
      get() {
        return this.$store.state.menu.version;
      },
      set(val) {
        this.$store.state.menu.version = val;
      }
    },
    getdomain: {
      get() {
        return this.$store.state.menu.jump_domain_url;
      }
    },
    datalist: {
      get() {
        return this.$store.state.checkicp.datalist;
      },
      set(val) {
        this.$store.state.checkicp.datalist = val;
      }
    },
    isdata: {
      get() {
        return this.$store.state.checkicp.isdata;
      },
      set(val) {
        this.$store.state.checkicp.isdata = val;
      }
    },
    apitoken:{
      get(){
        return this.$store.state.menu.apitoken;
      },
      set(val){
        this.$store.state.menu.apitoken=val;
      }
    }
  },
  mounted() {
    this.ASetHistory("checkicp").then(flag => {
      if (flag) {
        this.listen();
      }
    });
  },
  methods: {
    ...mapActions("menu", ["ASetHistory"]),
    listen() {
      this.$messenger.addTarget(window.parent, "parent");
      this.$messenger.targets["parent"].send("_5118_Seo_ICP_Domain_Info",this.apitoken);

      this.$messenger.listen("_5118_Web_ICP_List_info", msg => {
        if (msg) {
          this.datalist = JSON.parse(msg);
          if(this.datalist.icp_license){
              this.isdata=true;
          }
          else{
              this.isdata=false;
          }
        }
      });
    },
    reptime(time){
      let retime=''
      if(time){
        retime=time.replace('T00:00:00','');
        return retime;
      }
      return retime;
    },
    get_index_url(urls){
      urls=urls.split("|")[0]
      window.console.log(urls);
      return urls
    },
    jump_domain_url(url) {
      window.open(this.$geticpurl+"/domain/" + url);
    },
    jump_icp_url(url) {
      window.open(this.$geticpurl+"/icp/" + url);
    },
    jump_name_url(url) {
      window.open(this.$geticpurl+"/name/" + url.encodeUnicode());
    },
    jump_company_url(url) {
      window.open(this.$geticpurl+"/company/" + url.encodeUnicode());
    },
  }
};
</script>

<style type="text/less" lang="less" scoped>
@import "../assets/style/color";
@import "../assets/style/config";
@import "../assets/style/mixin";
.icpinfo {
  margin-top: 20px;
  font-size: 12px;
  padding-bottom: 10px;
  span {
    font-size: 14px;
    font-weight: bold;
    color: #2f3a74;
  }
  p {
    margin-top: 8px;
  }
  .spancolor {
    color: @theme-color;
    cursor: pointer;
  }
  .pleft {
    float: left;
  }
  .pright {
    float: right;
  }
  .lineheight {
    margin-top: 35px;
  }
}
.btnbox {
  padding: 3px 60px;
}
.companyLength{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/CheckICP.vue